import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=0fa339e2&scoped=true"
import script from "./AddBankAccount.vue?vue&type=script&lang=js"
export * from "./AddBankAccount.vue?vue&type=script&lang=js"
import style0 from "./AddBankAccount.vue?vue&type=style&index=0&id=0fa339e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa339e2",
  null
  
)

export default component.exports